import { StatsData } from './useFetchVideoStats';

export const useKpiStats = (statsData: StatsData | null) => {
    const uploaded = statsData?.uploadedFilesCount ?? 0;
    const notUploaded = statsData?.notUploadedFilesCount ?? 0;
    const scheduled = statsData?.scheduledFilesCount ?? 0;
    const subtitleUpdated = statsData?.subtitleUpdatedFilesCount ?? 0;

    const total = uploaded + scheduled + notUploaded;
    const notScheduled = total - scheduled - notUploaded;
    const totalUploaded = uploaded + scheduled;
    const subtitleNotUpdated = total - subtitleUpdated;

    return {
        total,
        uploaded: totalUploaded,
        notUploaded,
        scheduled,
        notScheduled,
        subtitleUpdated,
        subtitleNotUpdated,
        uploadedPct: total ? ((totalUploaded / total) * 100).toFixed(2) : '0',
        notUploadedPct: total ? ((notUploaded / total) * 100).toFixed(2) : '0',
        scheduledPct: totalUploaded
            ? ((scheduled / totalUploaded) * 100).toFixed(2)
            : '0',
        notScheduledPct: totalUploaded
            ? ((notScheduled / totalUploaded) * 100).toFixed(2)
            : '0',
        subtitleUpdatedPct: total
            ? ((subtitleUpdated / total) * 100).toFixed(2)
            : '0',
        subtitleNotUpdatedPct: total
            ? ((subtitleNotUpdated / total) * 100).toFixed(2)
            : '0',
    };
};
